import React, { useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { LoadableComponentContext } from '@wix/da-hooks/pkg/useLoadableComponent';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import { CommentEditorContext } from '../../../CommentEditor/context';
import { CommentEditorSource } from '../../../CommentEditor/redux/types';
import { focusEditor } from '../../../CommentEditor/redux/actionCreators';
import s from './LazyPlaceholder.scss';

export interface Props {}

/**
 * What we'll show instead of the editor if the DaEditor chunk isn't loaded yet.
 *
 * It's a button that'll trigger the chunk to load.
 */
const LazyPlaceholder: React.FC<Props> = () => {
  const { t } = useTranslation();
  const { editorSource, editorId } = useContext(CommentEditorContext);
  const dispatchFocusEditor = useAction(focusEditor);
  const {
    triggerProps: { onClick, ...restTriggerProps },
  } = useContext(LoadableComponentContext);

  const handleClick = useCallback(() => {
    onClick();
    dispatchFocusEditor(editorId);
  }, [onClick, dispatchFocusEditor, editorId]);

  return (
    <PlainButtonOrLink
      className={s['root']}
      onClick={handleClick}
      {...restTriggerProps}
    >
      {editorSource === CommentEditorSource.Reply
        ? t('commentbox.editor.placeholder.reply')
        : t('commentbox.editor.placeholder')}
    </PlainButtonOrLink>
  );
};
LazyPlaceholder.displayName = 'LazyPlaceholder';

export default LazyPlaceholder;
